import React from 'react'
import SkillsComponent from '../../components/skills/skillsComponent'
import Footer from '../../components/footer/footer'
import Header from '../../components/header/Header'
import { Helmet } from 'react-helmet'
export default function Skills() {
  return (
    <>
    <Helmet>
            <title>Skills — Gopal Goyal | AI, Cloud & Full-Stack</title>
            <meta name='description'
            content='Skills of Gopal Goyal — Python, C++, JavaScript, ReactJS, Node.js, FastAPI, AWS, LLMs, NLP, and databases like SQL, MongoDB, and Pinecone.'/>
            <meta name='keywords' content='Gopal Goyal skills, Python, ReactJS, FastAPI, AWS, LLMs, NLP, MongoDB, Pinecone'/>
        </Helmet>
    <Header/>
        <SkillsComponent/>
        <Footer/>
    </>
  )
}
